/**
 * Form component for expense line items
 */

import React from 'react';
import { Grid, TextField, IconButton, InputAdornment, Box } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import type { ExpenseItem } from '../../../types/ExpenseItem';

interface ExpenseItemFormProps {
  item: ExpenseItem;
  onChange: (item: ExpenseItem) => void;
  onRemove: () => void;
}

export const ExpenseItemForm: React.FC<ExpenseItemFormProps> = ({
  item,
  onChange,
  onRemove,
}) => {
  const handleChange = (field: keyof ExpenseItem, value: string | number) => {
    onChange({
      ...item,
      [field]: value,
    });
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Name */}
        <Grid size={{ xs: 12, sm: 8, md: 9 }}>
          <TextField
            label="Expense Name"
            placeholder="e.g., Security, Sound Engineer"
            value={item.name}
            onChange={(e) => handleChange('name', e.target.value)}
            size="small"
            fullWidth
          />
        </Grid>

        {/* Amount and Delete */}
        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              label="Amount"
              type="number"
              value={item.amount}
              onChange={(e) => handleChange('amount', parseFloat(e.target.value) || 0)}
              size="small"
              fullWidth
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
              inputProps={{ min: 0, step: 0.01 }}
            />
            <IconButton
              color="error"
              size="small"
              aria-label={`Remove expense ${item.name || 'item'}`}
              onClick={onRemove}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
